require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interviste-marco-krahenbuhl.json") })
        }
      }, "path---interviste-marco-krahenbuhl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interviste-marco-krahenbuhl!./.cache/json/interviste-marco-krahenbuhl.json
// module id = 680
// module chunks = 231608221292675